import { NgClass } from '@angular/common';
import { Component, computed, ElementRef, inject, input, viewChild } from '@angular/core';
import { DashboardLayoutService } from '../../services/layout';
import { ToolbarConfig } from './toolbar-config';


@Component({
	selector: 'toolbar',
	standalone: true,
	imports: [NgClass],
	templateUrl: './toolbar.widget.html',
	styleUrls: ['toolbar.widget.scss'],
})
export class ToolbarWidget {
	private layoutService = inject(DashboardLayoutService);

	private readonly toolbarDiv = viewChild<ElementRef<HTMLInputElement>>('toolbar');
	public readonly config = input.required<ToolbarConfig>();

	public isScrollable = computed(() => {

		const toolbar = this.toolbarDiv();
		if (toolbar) {
			return this.layoutService.isScrollable(toolbar.nativeElement).horizontallyScrollable;
		}

		return false;
	});
}